import { useMemo, useRef } from 'react';

import useCheckRoute, { UseCheckRoute } from 'hooks/useCheckRoute';
import useModal from 'hooks/useModal';
import { useUserInfo } from 'hooks/useUserInfo';

import { getTabs, Tab } from './config';
import { ProfileRef } from './types';

const useHeader = () => {
  // region *******************************DATA*********************************
  const routesState: UseCheckRoute = useCheckRoute();

  const [showProfile, handleToggleProfile] = useModal();

  const profileRef: ProfileRef = useRef<Nullable<HTMLDivElement>>(null);

  const {
    currentUserInfo: userInfo,
    isCurrentUserInfoLoading,
    isUserTenantUser: isTenantUser,
  } = useUserInfo();

  const tabs: Tab[] = useMemo(
    () => (!userInfo ? [] : getTabs(isTenantUser)),
    [isTenantUser, userInfo]
  );

  const screenWidth: number = window.innerWidth;

  const isMobile: boolean = screenWidth < 768;

  return useMemo(
    () => ({
      handleToggleProfile,
      showProfile,
      routesState,
      tabs,
      isMobile,
      profileRef,
      isCurrentUserInfoLoading,
    }),
    [
      handleToggleProfile,
      showProfile,
      routesState,
      tabs,
      isMobile,
      isCurrentUserInfoLoading,
    ]
  );
};

export default useHeader;
